import { render, staticRenderFns } from "./POIWidget.vue?vue&type=template&id=2d35c6b7"
import script from "./POIWidget.js?vue&type=script&lang=js&external"
export * from "./POIWidget.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports